import { apiClient } from '@/lib/api';
import { AuthTokenStorageService } from './auth-token-storage';

export const AuthService = {
  authenticate(token: string) {
    AuthTokenStorageService.store(token);
    apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  },

  logout() {
    if (apiClient.defaults.headers.common) {
      const headersCommon = apiClient.defaults.headers.common;
      delete headersCommon.Authorization;
      apiClient.defaults.headers.common = headersCommon;
    }

    AuthTokenStorageService.clear();
  },

  isAuthenticated() {
    return !!AuthTokenStorageService.getAccessToken();
  },
};
